const updateIframeHeight = iframeElement => {
  if (!iframeElement) {
    return;
  }

  const iframeBodyElement = iframeElement.contentWindow.document.body;

  iframeElement.style.height = `${Math.max(iframeBodyElement.scrollHeight, iframeBodyElement.offsetHeight)}px`;
};

const updateTiktokIframeHeight = iframeElement => {
  if (!iframeElement) {
    return;
  }

  const FIXED_HEIGHT = 776;

  iframeElement.style.height = `${FIXED_HEIGHT}px`;
};

const changeIframeHeight = iframeElement => {
  const isTiktok = iframeElement.contentWindow.document.querySelector('.tiktok-embed');

  if (isTiktok) {
    const resizeObserver = new iframeElement.contentWindow.ResizeObserver(() => updateTiktokIframeHeight(iframeElement));

    resizeObserver.observe(iframeElement.contentWindow.document.body);
    return;
  }
  const resizeObserver = new iframeElement.contentWindow.ResizeObserver(() => updateIframeHeight(iframeElement));

  resizeObserver.observe(iframeElement.contentWindow.document.body);
};

const toggleLoadingWithFrame = (iframeElement, loadingSkeletonElement) => {
  iframeElement.classList.remove('position-absolute');
  loadingSkeletonElement.classList.add('hidden');
};

const initEmbed = (iframeElement, loadingSkeletonElement) => {

  iframeElement.onload = function() {
    toggleLoadingWithFrame(iframeElement, loadingSkeletonElement);
    changeIframeHeight(iframeElement);
  };
};

const initEmbeds = containerElement => {
  if (!containerElement) {
    return;
  }

  const customBlockElements = containerElement.querySelectorAll('.custom-html');

  Array.from(customBlockElements).forEach(customBlockElement => {
    const loadingSkeletonElement = customBlockElement.querySelector('.loading-skeleton');

    if (!loadingSkeletonElement.classList.contains('loading-skeleton')) {
      return;
    }

    initEmbed(customBlockElement.querySelector('iframe'), loadingSkeletonElement);
  });
};

export {initEmbeds};
